import React, { useEffect, useState } from 'react';
import DashedLineChart from 'Pages/GMS/Performance/Components/DashedLineChart';
import { ChartTypes } from 'Pages/GMS/Performance/Components/ChartTypes';
import ColumnChart from 'Pages/GMS/Performance/Components/ColumnChart';
import ColumnAndLineChart from 'Pages/GMS/Performance/Components/ColumnAndLineChart';
import { getABAnalytics } from '../../services/ABServices';
import { toast } from 'react-toastify';
import CompatioLoader from 'Components/Common/components/CompatioLoader';
import NoDataComponent from 'Components/Common/NoDataComponent';

const ResultAnalytics = ({ testId }: { testId: string }) => {
    const [selectedChartItem, setSelectedChartItem] = useState<string>("Line Chart");
    const [analyticsData, setAnalyticsData] = useState<any>(null)
    const [keys, setKeys] = useState<string[]>([])
    const [loading, setLoading] = useState<boolean>(false)

    const columLineData = (data: any) => {
        return data.map((x: any) => {
            return {
                name: x?.name,
                columnData: x?.data,
                lineData: x?.data
            }
        })
    }

    const getAnalyticsData = async () => {
        try {
            setLoading(true)
            const res = await getABAnalytics(testId)
            if (res) {
                setAnalyticsData(res)
                setKeys(Object.keys(res))
            }
            else toast.info("Couldnt get the analytics data")
        } catch (error) {
            setLoading(false)
        }
        finally { setLoading(false) }
    }

    useEffect(() => {
        getAnalyticsData()
    }, [])

    return (
        loading ?
            <CompatioLoader />
            :
            <section>
                <div className="tw-flex tw-flex-wrap">
                    {
                        keys?.map((x, i) =>
                        (<div key={x} className={`tw-rounded  tw-w-[48%] tw-m-2 tw-bg-greys-000 tw-shadow-[0px_4px_12px_rgba(0,_0,_0,_0.08)] tw-box-border  tw-h-auto tw-border-[1px] tw-border-solid tw-border-lightgray`}>
                            <div className={`tw-flex tw-justify-between tw-items-center tw-pt-2 tw-px-2 tw-border-b-2`}>
                                <label className={`tw-text-sm tw-ps-1 tw-font-medium tw-text-[#091E42]`}>{x}</label>
                                <div className={`tw-flex tw-items-center tw-gap-1 tw-pe-2`}>
                                    {/* <span className='tw-cursor-pointer'><ReportIcon /></span> */}
                                    <ChartTypes selectedItem={selectedChartItem} setSelectedItem={setSelectedChartItem} />
                                </div>
                            </div>
                            {
                                analyticsData[x as keyof typeof analyticsData]?.data?.length > 0 ?
                                    <>
                                        {selectedChartItem === "Line Chart" ? <DashedLineChart data={analyticsData[x as keyof typeof analyticsData]?.data} xAxis={analyticsData[x as keyof typeof analyticsData]?.xAxis} granularity='PT2D' dashedArray={[]} timezone='UTC' metricName={x} /> : null}
                                        {selectedChartItem === "Column Chart" ? <ColumnChart data={analyticsData[x as keyof typeof analyticsData]?.data} metricName={x} xAxis={analyticsData[x as keyof typeof analyticsData]?.xAxis} granularity='PT2D' timezone={"UTC"} /> : null}
                                        {selectedChartItem === "Line & Column" ? <ColumnAndLineChart data={
                                            columLineData(
                                                analyticsData[x as keyof typeof analyticsData]?.data
                                            )} xAxis={analyticsData[x as keyof typeof analyticsData]?.xAxis} granularity='PT2D' timezone={"UTC"} /> : null}
                                    </>
                                    : <div className='tw-items-center tw-font-bold tw-h-[350px]'><NoDataComponent /></div>
                            }
                        </div>)
                        )}
                </div>
            </section>
    );
}

export default ResultAnalytics;